import { motion } from 'motion/react'

const tickVariants = {
  checked: {
    pathLength: 1,
    opacity: 1,
    transition: {
      duration: 0.1,
      delay: 0.02,
    },
  },
  unchecked: {
    pathLength: 0,
    opacity: 0,
    transition: {
      duration: 0.1,
    },
  },
}

export const SelectOptionSelectedIndicator = ({
  selected,
}: {
  selected: boolean
}) => {
  return (
    <div className="h-4 w-4 text-positive">
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="h-4 w-4"
        initial={false}
        animate={selected ? 'checked' : 'unchecked'}
      >
        <title>Selected indicator</title>
        <motion.path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.5 12.75l6 6 9-13.5"
          variants={tickVariants}
        />
      </motion.svg>
    </div>
  )
}
